import React, { Fragment } from 'react';
import CustomInput from '../InputCostum';
import styles from './InputPasswordAuth.module.scss';
import i18n from 'i18n';
import { capitalize } from "helpers/utils/utils_general";

export class PasswordInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visibility: 'password',
            showValidation: false
        }
    }

    onVisibilityChange = (event) => {
        event.preventDefault();
        if (this.state.visibility === 'password') {
            this.setState({
                visibility: 'text'
            })
        } else {
            this.setState({
                visibility: 'password'
            })
        }
    }

    handleFocus = (e) => {
        this.setState({
            showValidation: true
        })
    }

    handleBlur = (e) => {
        this.setState({
            showValidation: false
        })
    }

    render() {
        const {
            id,
            error,
            validationResults = [],
            validate
        } = this.props;

        const validationContent = validationResults.every((v) => v === true) ? <div className={styles["safe-password"]}>{i18n.t("secure.password")}</div> :
            <Fragment>
                <p className={styles["validation-title"]}>{i18n.t("must.contain")}</p>
                <div className={styles["validation-items"]}>
                    <p className={
                        styles["validation-item"] + (validationResults[0] ? ' ' + styles["valid"] : "")
                    }>
                        <i className={
                            "icon " + (validationResults[0] ? "icon-check" : "icon-cruz")
                        } />
                        {i18n.t("least.8.characters")}
                    </p>
                    <p className={
                        styles["validation-item"] + (validationResults[1] ? ' ' + styles["valid"] : "")
                    }>
                        <i className={
                            "icon " + (validationResults[1] ? "icon-check" : "icon-cruz")
                        } />
                        {i18n.t("least.one.number")}
                    </p>
                    <p className={
                        styles["validation-item"] + (validationResults[2] ? ' ' + styles["valid"] : "")
                    }>
                        <i className={
                            "icon " + (validationResults[2] ? "icon-check" : "icon-cruz")
                        } />
                        {i18n.t("least.one.letter")}
                    </p>
                </div>
            </Fragment>
        return (
            <div className={styles["password-group"]}>
                <CustomInput controlVisibility={true} handleFocus={this.handleFocus} handleBlur={this.handleBlur} handleChange={this.props.handleChange} id={id} type={this.state.visibility} error={error} placeholder={capitalize(i18n.t("password"))} icon="icon-candado" handleVisibility={this.onVisibilityChange}></CustomInput>
                {(this.state.showValidation && validate && !error) && <div className={styles["validation"]}>
                    {validationContent}
                </div>}
            </div>
        )
    }

}


PasswordInput.propTypes = {

};

export default PasswordInput;